<template>
  <span
    class="pagination__total"
  >{{i18n.t('el.pagination.total', { total: $parent.total })}}</span>
</template>
<script>
import i18n from '@/lang'

export default {
  data () {
    return {
      i18n
    }
  }
}
</script>
